import {FilterEnum} from 'Agent/Accounts/ducks/account';

export enum LineOfBusiness {
  Agent = 1,
}

export const LinesOfBusinessCustomerSupport: FilterEnum[] = [
  {
    name: 'Agent',
    value: 'agent',
  },
];

export type LinesOfBusinessCustomerSupportValue = 'agent';
